import { configureStore } from '@reduxjs/toolkit';
import uniformReducer from './slices/uniformSlice';

export const store = configureStore({
  reducer: {
    uniform: uniformReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable for date objects in uniform data
    }),
});

export default store;
